import { useCallback, useMemo, useState } from 'react';
// @ts-ignore — CommonJS module from @scoutfdc/common
const AttributeTypes = require('@scoutfdc/common/lib/attribute_types');
const DEFAULT_CODES = {
    oil_inventory: AttributeTypes.oil_inventory,
    oil_sales: AttributeTypes.oil_sales,
    oil_production: AttributeTypes.oil_production,
};
const ATTRIBUTE_KEYS = ['oil_inventory', 'oil_sales', 'oil_production', 'secondary_oil_sales'];
const CODE_PATTERN = /^[1-9]\d*$/;
const INVALID_CODE_MESSAGE = 'Must be a valid integer (attribute type code).';
function storedAttributes(org) {
    var _a;
    const option = (_a = org === null || org === void 0 ? void 0 : org.options) === null || _a === void 0 ? void 0 : _a.oil_inventory;
    if (typeof option !== 'object' || option === null || Array.isArray(option) || !('attributes' in option)) {
        return {};
    }
    const rawAttributes = option.attributes;
    if (typeof rawAttributes !== 'object' || rawAttributes === null || Array.isArray(rawAttributes)) {
        return {};
    }
    const attributes = rawAttributes;
    return attributes;
}
function textForStoredValue(value) {
    if (typeof value === 'number' && Number.isInteger(value)) {
        return String(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    return '';
}
function valuesForOrganization(org) {
    const attributes = storedAttributes(org);
    return {
        oil_inventory: textForStoredValue(attributes.oil_inventory) || String(DEFAULT_CODES.oil_inventory),
        oil_sales: textForStoredValue(attributes.oil_sales) || String(DEFAULT_CODES.oil_sales),
        oil_production: textForStoredValue(attributes.oil_production) || String(DEFAULT_CODES.oil_production),
        secondary_oil_sales: textForStoredValue(attributes.secondary_oil_sales),
    };
}
function parseCode(value) {
    const trimmed = value.trim();
    if (!CODE_PATTERN.test(trimmed)) {
        return null;
    }
    const parsed = Number(trimmed);
    return Number.isInteger(parsed) ? parsed : null;
}
export function useOilInventoryAttributesField(org) {
    const initialValues = useMemo(() => valuesForOrganization(org), [org]);
    const [values, setValues] = useState(() => initialValues);
    const [errors, setErrors] = useState({});
    const setValue = useCallback((key, value) => {
        setValues((previous) => ({ ...previous, [key]: value }));
    }, []);
    const reset = useCallback(() => {
        setValues(initialValues);
        setErrors({});
    }, [initialValues]);
    const validate = useCallback(() => {
        const nextErrors = {};
        for (const key of ATTRIBUTE_KEYS) {
            if (values[key].trim() !== '' && parseCode(values[key]) === null) {
                nextErrors[key] = INVALID_CODE_MESSAGE;
            }
        }
        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    }, [values]);
    const toOptionsPatch = useCallback(() => {
        if (ATTRIBUTE_KEYS.every((key) => values[key] === initialValues[key])) {
            return {};
        }
        const attributes = {};
        for (const key of ATTRIBUTE_KEYS) {
            const trimmed = values[key].trim();
            if (trimmed === '') {
                continue;
            }
            const parsed = parseCode(values[key]);
            if (parsed === null) {
                return {};
            }
            attributes[key] = parsed;
        }
        return { oil_inventory: { attributes } };
    }, [values, initialValues]);
    return { values, setValue, errors, validate, reset, toOptionsPatch };
}
